import { asAbsolute } from 'root/routes/utils';
import consts from 'common/consts';
import AboutPage from '../AboutPage';

export default [
  {
    path: asAbsolute(consts.ABOUT),
    component: AboutPage,
  },
];
